export const PISPASEPFGTS_IMPRESSAO_SOLICITADA = 'PISPASEPFGTS_IMPRESSAO_SOLICITADA';
export const PISPASEPFGTS_IMPRESSAO_RECEBIDA = 'PISPASEPFGTS_IMPRESSAO_RECEBIDA';
export const PISPASEPFGTS_ERRO_IMPRESSAO_RECEBIDO = 'PISPASEPFGTS_ERRO_IMPRESSAO_RECEBIDO';
export const PISPASEPFGTS_LIMPAR_MENSAGEM = 'PISPASEPFGTS_LIMPAR_MENSAGEM';
export const PISPASEPFGTS_NAO_ENCONTRADA = 'PISPASEPFGTS_NAO_ENCONTRADA';
export const PISPASEPFGTS_ERRO_ELO = 'PISPASEPFGTS_ERRO_ELO';
